import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('Required'),
  assigned_to: Yup.array().of(Yup.string()),
  shipper_id: Yup.array().of(Yup.string()),
  vehicle_type: Yup.array().of(Yup.string()),
  working_area_id: Yup.array().of(Yup.string()),
});
